import { render } from "./TemplateListForm.vue?vue&type=template&id=05f6fda0&scoped=true&ts=true"
import script from "./TemplateListForm.vue?vue&type=script&lang=ts"
export * from "./TemplateListForm.vue?vue&type=script&lang=ts"

import "./TemplateListForm.vue?vue&type=style&index=0&id=05f6fda0&scoped=true&lang=css"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f6fda0"]])

export default __exports__